import React, { useEffect, useState } from 'react';
import './PayStubsDashboard.css';
import { BackButton } from '../../../Utilities/components/Buttons';
import Footer from '../../../Footer';

const PayStubsDashboard = () => {
  const [payStubs, setPayStubs] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState('2025');
  const stubsPerPage = 6;

  useEffect(() => {
    // Simulated fetch - in real app, fetch from Gusto API with selectedYear
    const allStubs = [
      // Simulated historical data for pagination demonstration
      ...Array.from({ length: 24 }, (_, i) => {
        const id = i + 1;
        const payDate = new Date(2025, 4 - Math.floor(i / 2), (i % 2 === 0 ? 5 : 20));
        return {
          id,
          dateRange: `April ${i % 2 === 0 ? '16 - 30' : '1 - 15'}, ${payDate.getFullYear()}`,
          payDate: payDate.toDateString(),
          grossPay: 1500 + i * 10,
          netPay: 1350 + i * 10,
          hoursWorked: 75,
          overtimeHours: i % 2 === 0 ? 2 : 0,
          bonuses: i % 3 === 0 ? 100 : 0,
          deductions: 150,
          employerContributions: 190,
          downloadable: true
        };
      })
    ];

    const yearFiltered = allStubs.filter(stub => stub.payDate.includes(selectedYear));
    setPayStubs(yearFiltered);

    // Set available years dynamically
    const availableYears = [...new Set(allStubs.map(s => new Date(s.payDate).getFullYear().toString()))];
    setYears(availableYears);
  }, [selectedYear]);

  const startIdx = currentPage * stubsPerPage;
  const paginatedStubs = payStubs.slice(startIdx, startIdx + stubsPerPage);

  const handlePrev = () => setCurrentPage(prev => Math.max(prev - 1, 0));
  const handleNext = () => {
    if ((currentPage + 1) * stubsPerPage < payStubs.length) setCurrentPage(prev => prev + 1);
  };

  return (
    <div>
      <div className="container">
        <BackButton />
        <div className="paystubs-dashboard-container">
          <h2 className="paystubs-header">💰 Pay Stubs</h2>
          <p className="paystubs-subtext">Your pay breakdowns, earnings insights, and download access</p>

          <div className="paystubs-year-selector">
            <label htmlFor="year">Select Year: </label>
            <select id="year" value={selectedYear} onChange={(e) => { setSelectedYear(e.target.value); setCurrentPage(0); }}>
              {years.map(year => <option key={year} value={year}>{year}</option>)}
            </select>
          </div>

          <div className="paystubs-section">
            {paginatedStubs.map((stub) => (
              <div key={stub.id} className="paystub-card">
                <div className="paystub-top-row">
                  <div className="paystub-period">{stub.dateRange}</div>
                  <div className="paystub-download">
                    {stub.downloadable && <a href={`/downloads/paystub-${stub.id}.pdf`} className="paystub-download-link">Download PDF</a>}
                  </div>
                </div>
                <div className="paystub-grid">
                  <div><strong>Pay Date:</strong> {stub.payDate}</div>
                  <div><strong>Hours Worked:</strong> {stub.hoursWorked} hrs</div>
                  <div><strong>Overtime Hours:</strong> {stub.overtimeHours} hrs</div>
                  <div><strong>Bonuses:</strong> ${stub.bonuses.toFixed(2)}</div>
                  <div><strong>Gross Pay:</strong> ${stub.grossPay.toFixed(2)}</div>
                  <div><strong>Deductions:</strong> -${stub.deductions.toFixed(2)}</div>
                  <div><strong>Employer Contributions:</strong> +${stub.employerContributions.toFixed(2)}</div>
                  <div className="paystub-net"><strong>Net Pay:</strong> ${stub.netPay.toFixed(2)}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="paystubs-pagination">
            <button onClick={handlePrev} disabled={currentPage === 0}>Previous</button>
            <span>Page {currentPage + 1}</span>
            <button onClick={handleNext} disabled={(currentPage + 1) * stubsPerPage >= payStubs.length}>Next</button>
          </div>
        </div>
      </div>
      <hr />
      <Footer />
    </div>
  );
};

export default PayStubsDashboard;